module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flights.length > 0) ? _c('div', [_c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "filter"
  }), _c('div', {
    staticClass: "sort"
  }, [_c('div', {
    staticClass: "space"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          Sort by\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "selection",
    on: {
      "click": function($event) {
        _vm.sorting.menu = !_vm.sorting.menu
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.sorting.selection.display) + "\n            ")]), _vm._v(" "), (_vm.sorting.menu) ? _c('div', {
    staticClass: "menu-box"
  }, _vm._l((_vm.sorting.options), function(option) {
    return _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "option",
      on: {
        "click": function($event) {
          _vm.sort(option)
        }
      }
    }, [_vm._v(_vm._s(option.display))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      active: _vm.sorting.menu
    },
    on: {
      "click": function($event) {
        _vm.sorting.menu = !_vm.sorting.menu
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])])])])]), _vm._v(" "), _c('ul', _vm._l((_vm.flights), function(flight) {
    return _c('li', [_c('flight', {
      attrs: {
        "flight": flight
      }
    })], 1)
  }))]) : _c('div', [_vm._v("Sorry, there are no flights currently available for this origin and destination.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c30dcec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flights.vue
// module id = 66
// module chunks = 1